'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', function($modal) {
    return {
        warning: warning,
        danger: danger,
    };

    function warning(opts) {
        return $modal.open({
            template: require('../view/confirm-modal.html'),
            controller: 'ModalConfirmController',
            size: 'sm',
            backdrop: false,
            windowClass: 'modal-warning',
            resolve: {
                opts: function() {
                    return {
                        title: opts.title != null ? opts.title : 'Внимание!',
                        message: opts.message != null ? opts.message : '',
                        apply: opts.apply != null ? opts.apply : 'Да',
                        cancel: opts.cancel != null ? opts.cancel : 'Нет',
                    };
                },
            },
        });
    }

    function danger(opts) {
        return $modal.open({
            template: require('../view/confirm-modal.html'),
            controller: 'ModalConfirmController',
            size: 'sm',
            backdrop: false,
            windowClass: 'modal-danger',
            resolve: {
                opts: function() {
                    return {
                        title: opts.title != null ? opts.title : 'Внимание!',
                        message: opts.message != null ? opts.message : '',
                        apply: opts.apply != null ? opts.apply : 'Да',
                        cancel: opts.cancel != null ? opts.cancel : 'Нет',
                    };
                },
            },
        });
    }
}];
